document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.custom-content[data-section-type="adv-content"]');
  
  sections.forEach(section => {
    // Vérifie si l'effet est activé via un attribut data
    if (section.dataset.mobileScrollFloat === 'true') {
      let lastScrollTop = 0;
      
      window.addEventListener('scroll', function() {
        // Vérifie si l'écran est en mode mobile
        if (window.innerWidth <= 749) {
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          
          if (scrollTop < lastScrollTop) {
            // Scroll vers le haut
            section.classList.add('float-right');
          } else {
            // Scroll vers le bas
            section.classList.remove('float-right');
          }
          
          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        }
      });
    }
  });
});